<template>
	<div>
		<div class="monitor_section" v-loading="loading">
			<h3>最新缺陷记录</h3>

			<div v-show="defects.length == 0 && !loading">
				<span>还没有缺陷记录.</span>
			</div>

			<div id="defect_view" class="view">
				<div class="defect_item" v-for="item in defects" :key="item._id.$oid">
					<div class="img_item">
						<img :src="item.img" alt @error="nofindImg()" />
					</div>
					<div class="defectInfo">
						<ul>
							<li>
								<label for>位置：</label>
								<span v-text="item.meter"></span>
							</li>
							<li>
								<label for>检测面：</label>
								<span v-text="item.side_index"></span>
							</li>
							<li>
								<label for>缺陷类型：</label>
								<span v-text="item.type_index"></span>
							</li>
							<li>
								<label for>面积：</label>
								<span v-text="item.area"></span>
							</li>
						</ul>

						<ul>
							<li>
								<label for>张号：</label>
								<span v-text="item.sheet_index"></span>
							</li>
							<li>
								<label for>联号：</label>
								<span v-text="item.col"></span>
							</li>
							<li>
								<label for>强度：</label>
								<span v-text="item.energy"></span>
							</li>
						</ul>
					</div>

					<div class="clearfix"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import maxwindous from './maxWindous.js'
	import { getDefectRequest, getDefectImageUrlByMd5 } from '../../network/requests/defect'
	import { defectStatisRequest } from '../../network/requests/defectStatis'

	export default {
		props: ['jtInfo'],
		components: {},
		mixins: [maxwindous],
		data() {
			return {
				demoImage: require('@/assets/images/demo_01.jpg'),
				// jtInfo: null,
				defects: [],
				roll_id: '',
				fullscreen: false,
				loading: false,
				timer: null,
			}
		},
		computed: {
			monitorTime() {
				var value = 5
				var lv = localStorage.getItem('MonitorTime')
				if (lv) {
					value = lv
				}

				return value * 1000
			},
		},
		methods: {
			/**
			 * 查看机台状态。
			 */
			async handleSelectJT(jtInfo) {
				this.jtInfo = jtInfo
				console.log('查看机台', jtInfo)

				this.loading = true

				try {
					//获取最新
					await this.getNewstDefectData()
					//显示缺陷记录。
					await this.bindDefects()
				} catch (error) {
					this.defects = []
					console.error(error)
				} finally {
					this.loading = false
				}

				this.timer = setInterval(async () => {
					//获取最新
					await this.getNewstDefectData()
					//显示缺陷记录。
					await this.bindDefects()
				}, this.monitorTime)
			},
			async getNewstDefectData() {
				var defectStatis = (
					await defectStatisRequest.queryPage({
						page: 1,
						pagesize: 1,
						filter: { jt_id: this.jtInfo._id.$oid },
						sort: { _id: -1 },
						keys: { _id: 1 },
					})
				).data._embedded

				var defects = []
				if (defectStatis.length > 0) {
					this.roll_id = defectStatis[0]._id.$oid

					//获取最新的10个缺陷记录。
					defects = (
						await getDefectRequest(this.roll_id).queryPage({
							page: 1,
							pagesize: 10,
							filter: undefined,
							sort: { _id: -1 },
						})
					).data._embedded
				}

				this.defects = defects
			},
			async bindDefects() {
				if (this.defects.length == 0) return

				console.log('绑定缺陷记录', this.defects)
				var tempArray = []
				for (var item of this.defects) {
					var img = getDefectImageUrlByMd5(item.md5, this.roll_id)

					tempArray.push({ ...item, img })
				}

				this.defects = tempArray
			},
			nofindImg() {
				const img = event.srcElement
				img.src = require('@/assets/images/img.png')
				img.onerror = null //防止一直跳动
			},
		},
		created() {},
		destroyed() {
			clearInterval(this.timer)
		},
		mounted: {},
	}
</script>

<style scoped>
	.form-table {
		margin-bottom: 20px;
	}

	.defect_item {
		border: 1px #eee solid;
		float: left;
		width: 150px;
		margin-left: 5px;
		margin-right: 5px;
		margin-bottom: 10px;
	}
	.defect_item:hover {
		background-color: #eee;
	}

	.defectInfo {
		padding: 10px 20px 10px;
	}

	.defectInfo li {
		list-style: none;
		line-height: 20px;
		display: block;
		font-size: 12px;
	}

	.defectInfo li label {
		display: inline-block;
		color: #666;
	}

	.img_item {
		text-align: center;
	}
	.img_item img {
		height: 120px;
	}
	.view {
		background-color: #fff;
	}
</style>
